<template>
  <modal-card
    title="Send on demand info"
    fixed
    padding
    :loading="loading || snippetLoading || sending"
    @close="$emit('close')"
  >
    <div v-if="!success">
      <v-textarea v-model="onDemandText" auto-grow readonly rows="4" />
    </div>

    <InterviewSuccessMessage
      v-else
      title="Message Sent!"
      message="On-demand interview info has been sent to the contact."
    />

    <template #actions>
      <v-btn
        v-if="!success"
        color="appMain"
        class="light--text"
        :disabled="loading || snippetLoading || sending"
        @click="sendInfo"
      >
        Send
      </v-btn>
      <v-btn
        v-else
        color="appMain"
        class="light--text"
        @click="$emit('nextContact')"
      >
        Finish
      </v-btn>
    </template>
  </modal-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InterviewSuccessMessage from './InterviewSuccessMessage.vue';

export default {
  name: 'VectorOnDemandInfo',
  components: {
    InterviewSuccessMessage,
  },
  props: {
    contactId: String,
    loading: Boolean,
  },
  data() {
    return {
      snippetLoading: false,
      sending: false,
      onDemandText: '',
      success: false,
    };
  },
  watch: {
    contactId: {
      immediate: true,
      handler() {
        this.resetState();
        this.compileSnippet();
      },
    },
  },
  computed: {
    ...mapGetters('fields', ['getSingleField']),
    ...mapGetters('vector', ['getSingleVectorSnippet']),
    interviewField() {
      return this.getSingleField('interview_id');
    },
  },
  methods: {
    ...mapActions(['updateContact', 'compileTextForContact']),

    async sendInfo() {
      if (this.sending) return;

      this.sending = true;

      try {
        await this.addToInterview();

        this.$emit('sendMessage', {
          message: this.onDemandText,
          type: 'scheduled',
        });

        this.success = true;
      } finally {
        this.sending = false;
      }
    },

    async compileSnippet() {
      this.snippetLoading = true;

      try {
        const snippet = this.getSingleVectorSnippet(
          'vmc.interview_confirm.on_demand'
        );

        if (snippet) {
          const compiled = await this.compileTextForContact({
            contactId: this.contactId,
            content: snippet.text_content || '',
          });

          this.onDemandText = compiled;
        }
      } finally {
        this.snippetLoading = false;
      }
    },

    resetState() {
      this.success = false;
    },

    async addToInterview() {
      const field = this.interviewField;

      return this.updateContact({
        contactId: this.contactId,
        params: {
          [field.bucketId]: { [field.name]: '111' },
        },
        field,
        value: '111',
      });
    },
  },
};
</script>
